// extracted by mini-css-extract-plugin
module.exports = {"BreadCrumbWrapper":"Breadcrumb_BreadCrumbWrapper__6v9mg","BreadCrumbP":"Breadcrumb_BreadCrumbP__ul1AU"};